import { themes } from "services/constants";
import { toast } from "react-toastify";

export const getStatusColor = (status) => {
  switch (status) {
    case "Active":
      return themes.activeTap;
    case "Halfday":
    case "Leave":
      return themes.yellowColor;
    case "Late":
      return themes.lateTap;
    case "Absent":
      return themes.redColor;
    case "Break":
      return themes.breakTap;
    case "Out":
      return themes.out;
    case "Permission":
      return themes.permissionTap;
    case "Missing":
      return themes.lightOrange;
    case "Planned":
      return themes.planned;
    case "Early exit":
      return themes.earlyExit;
    case "Unassigned":
      return themes.unassigned;
    case "Week Off":
      return themes.whiteColor;
    case "Company holiday":
      return themes.holiday;
    default:
      return "black";
  }
};

export const getColorWorkingHours = (status) => {
  switch (status) {
    case "P":
      return themes.greenColor;
    case "L":
      return themes.yellowColor;
    case "A":
      return themes.redColor;
    case "W":
      return themes.whiteColor;
    case "M":
      return themes.lightOrange;
    case "H":
      return themes.holiday;
    case "PR":
      return themes.permissionTap;
    case "BR":
      return themes.breakTap;
    case "HL":
      return themes.halfDay;
    case "UA":
      return themes.blueColor;
    case "SP":
      return themes.pinkColor;
    case "NJ":
      return themes.darkGray;
    case "UN":
      return themes.unassigned;
    case "P2":
      return themes.planned;
    default:
      return "black";
  }
};

export const getCardBackgroundColor = (statusValue) => {
  if (statusValue === "Green") {
    return { backgroundColor: themes.lightGreen };
  } else if (statusValue === "Red") {
    return { backgroundColor: themes.lightRedColor };
  } else if (statusValue === "Yellow") {
    return { backgroundColor: themes.lightYellowColor };
  } else {
    return { backgroundColor: themes.primaryIndicator };
  }
};

export const showToast = (type, msg) => {
  switch (type) {
    case "success":
      toast.success(msg, { autoClose: 3000 });
      break;
    case "error":
      toast.error(msg, { autoClose: 3000 });
      break;
    case "info":
      toast.info(msg, { autoClose: 3000 });
      break;
    default:
      toast(msg, { autoClose: 3000 });
  }
};
